import {useDebugValue, useState} from 'react';

import {getObjectKeys, getKeyedObject, getNoUndefValuesObject} from '../../../utils/object';

function useValues(defaultValues, ...otherValues) {
    function getAllowedValues(values) {
        return getKeyedObject(values, getObjectKeys(defaultValues));
    }

    const specifiedValues = otherValues.reduce((accumulatedValues, currentValues) => ({
        ...accumulatedValues,
        ...getNoUndefValuesObject(currentValues)
    }), {});

    const initialValues = getAllowedValues({
        ...defaultValues,
        ...specifiedValues
    });

    const [
        currentValues,
        setCurrentValuesState
    ] = useState(initialValues);

    const [
        latestValues,
        setLatestValuesState
    ] = useState(initialValues);

    function setCurrentValues(nextValues) {
        setCurrentValuesState((prevValues) => (
            getAllowedValues({
                ...prevValues,
                ...nextValues
            })
        ));
    }

    function setCurrentValuesDefault() {
        setCurrentValues(defaultValues);
    }

    /* istanbul ignore next */
    function setCurrentValuesInitial() {
        setCurrentValues(initialValues);
    }

    function setCurrentValuesLatest() {
        setCurrentValues(latestValues);
    }

    function setLatestValues(nextValues) {
        setLatestValuesState((prevValues) => (
            getAllowedValues({
                ...prevValues,
                ...nextValues
            })
        ));
    }

    /* istanbul ignore next */
    function setLatestValuesDefault() {
        setLatestValues(defaultValues);
    }

    /* istanbul ignore next */
    function setLatestValuesInitial() {
        setLatestValues(initialValues);
    }

    /* istanbul ignore next */
    function setLatestValuesCurrent() {
        setLatestValues(currentValues);
    }

    function setAllValues(nextValues) {
        setCurrentValues(nextValues);
        setLatestValues(nextValues);
    }

    /* istanbul ignore next */
    function setAllValuesDefault() {
        setAllValues(defaultValues);
    }

    function setAllValuesInitial() {
        setAllValues(initialValues);
    }

    const result = {
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useValues};
